'use strict';

var _themeCurrency = require('@shopify/theme-currency');

// @start Quick ADD

var selection = [];
var subID;
var subscription = false;
var subscriptionTxt = '';
var qtyTxt = '';
var lastEl;
var activeQty;
var isSubPage = false;
var count = 0;
var allSelected = false;
var blendersChoice = false;
var activeVID;
var activeV = false;
var subLength = false;
var giftType = '';
var formFinished = false; // when all questions are filled out. This is used to flag when other options are being chosen 


var pathName = window.location.pathname;
var productType = window.theme.productType;

if (productType == 'subscription') {
  isSubPage = true;
  if (pathName == '/products/blenders-choice') {
    blendersChoice = true;
  }
}

$(document).on('click', '.product_content--quick-add-btn.quick-add', function () {
  var productID = $(this).attr('data-product-id');
  var variantID = $(this).attr('data-variant-id');
  var size = $(this).attr('data-size');
  var value = $(this).attr('data-value');
  productID = parseInt(productID);
  subscription = false;
  if (size > 1) {
    $('.variant-select-container-start-' + productID).addClass('hide');
    $('.variant-select-container-1-' + productID).removeClass('hide');
  } else {
    activeVID = variantID;
    addItemToCart(variantID, 1, false, productID);
  }
});

$(document).on('click', '.product_content--subscribe-btn', function (e) {

  if ($(this).hasClass('linked')) {
    return;
  }

  var productID = $(this).attr('data-product-id');
  subscription = true;
  $('.variant-select-container-start-' + productID).addClass('hide');
  $('.variant-select-container-0-' + productID).removeClass('hide');
});

$(document).on('click', '.variant-select', function () {

  if ($(this).hasClass('linked')) {
    return;
  }

  var position = $(this).attr('data-position');
  var productID = $(this).attr('data-product-id');
  var index = $(this).attr('data-index');
  var value = $(this).attr('data-value');
  var valueHandle = value.toLowerCase();
  var isSub = false;
  var newPosition;
  var ogProductID;
  var newEl;
  var firstButton;

  if ($(this).hasClass('gift')) {
    selection = [];
    allSelected = false;
    formFinished = false;
    $('.lets_review--readout').html('');
    $('.lets_review').addClass('hide');
    $('.step-end').addClass('hide');
    $('.step-qty').addClass('hide');
    $('.button-container').addClass('hide');
    $('.selected').removeClass('selected');
    $('.variant-select.gift').removeClass('selected');

    // $('.step-variants').addClass('hide');
    // $('.step-variants.step-1').addClass('hide');

    ogProductID = $(this).attr('data-og-product-id');
    giftType = $(this).attr('data-gift-type');

    $('.buttons-container-gift').addClass('hide');
    $('.button-container-' + productID).removeClass('hide');

    $(this).addClass('selected');

    $('.store-json-' + ogProductID).addClass('store-json-' + productID);

    if (giftType == 'coffee') {
      $('.qty-tea-title').addClass('hide');
      $('.qty-coffee-title').removeClass('hide');
    } else {
      $('.variant-select-container-1-' + productID + ' button').trigger('click');
      $('.qty-coffee-title').addClass('hide');
      $('.qty-tea-title').removeClass('hide');
    }
    return;
  }

  if ($(this).hasClass('subscribe')) {
    isSub = true;
    position = 0;
    $('.variant-select-container-0-' + productID).addClass('hide');
    $('.variant-select-container-1-' + productID).removeClass('hide');
  } else {

    if (isSubPage) {
      var parent = $(this).parent().parent();
      if (!$(this).hasClass('open-form')) {
        if ($(parent).hasClass('step-' + count)) {
          count = count + 1;
          $('.step-' + count).removeClass('hide');
        }
      }
    } else {
      newPosition = parseInt(position) + 1;
      newEl = $('.variant-select-container-' + newPosition + '-' + productID);
      $('.variant-select-container-' + position + '-' + productID).addClass('hide');
      $(newEl).removeClass('hide');
    }
  }

  if (!$(this).hasClass('open-form')) {
    $('.variant-select-container-' + position + '-' + productID + ' .variant-select').removeClass('selected');
    $('.variant-select-container-' + position + '-' + productID + ' .variant-select-' + index).addClass('selected');
    parseVariants(this, isSub);
  } else {
    $(this).addClass('selected');
    $('.office_party_form').fadeIn();
  }

  if (formFinished) {
    parseVariants(this, isSub);
  }

  if (valueHandle.includes('1 lb. can') || valueHandle.includes('can')) {
    newEl = $('.variant-select-container-' + newPosition + '-' + productID);
    firstButton = $(newEl).find('.variant-select-1');
    $(firstButton).trigger('click');
  }
});

function parseVariants(el, isSub, subLength) {

  if (isSub) {
    subID = $(el).attr('data-id');
  } else {
    console.log('yes');
    var size = $(el).attr('data-option-size'); // size of options
    var position = $(el).attr('data-position'); // position within options
    var productID = $(el).attr('data-product-id'); // product id
    var value = $(el).attr('data-value'); // value of selection
    var valueHandle = value.toLowerCase(); // handle

    var container = $('.store-json-' + productID); // button container

    var variant;
    var count;

    var cof3 = $(container).attr('data-coffee-3');
    var cof3Meta = $(container).attr('data-coffee-3-meta');

    var cof6 = $(container).attr('data-coffee-6');
    var cof6Meta = $(container).attr('data-coffee-6-meta');

    var tea3 = $(container).attr('data-tea-3');
    var tea3Meta = $(container).attr('data-tea-3-meta');

    var tea6 = $(container).attr('data-tea-6');
    var tea6Meta = $(container).attr('data-tea-6-meta');

    // these will hold the values when checking your selections
    var variantValue1;
    var variantValue2;
    var variantValue3;

    var selectedVariant;

    var variantID; // ID used to add to cart

    var variants = $(container).attr('data-obj'); // variant object

    if (isGift) {

      if (giftType == 'coffee') {
        if (subLength == 6) {
          subscriptions = JSON.parse(cof6Meta);
          variants = JSON.parse(cof6); // parse object
        } else {
          subscriptions = JSON.parse(cof3Meta);
          variants = JSON.parse(cof3); // parse object
        }
      } else {
        if (subLength == 6) {
          subscriptions = JSON.parse(tea6Meta);
          variants = JSON.parse(tea6); // parse object
        } else {
          subscriptions = JSON.parse(tea3Meta);
          variants = JSON.parse(tea3); // parse object
        }
      }
    } else {
      variants = decodeURIComponent(variants);
      variants = JSON.parse(variants); // parse object
    }

    variants = variants.variants;

    selection[position - 1] = value; // push to array

    lastEl = el;

    if (size == position || allSelected) {
      for (var i = 0; i < variants.length; i++) {
        variant = variants[i];

        variantValue1 = variant.option1;
        variantValue2 = variant.option2;
        variantValue3 = variant.option3;

        if (variantValue2 == null) {
          selection.splice(1, 1);
        }

        if (variantValue3 == null) {
          selection.splice(2, 1);
        }

        if (selection[0] && selection[1] && selection[2]) {
          if (selection[0] == variantValue1 && selection[1] == variantValue2 && selection[2] == variantValue3) {
            variantID = variant.id;
            selectedVariant = variant;
          }
        } else if (selection[0] && selection[1]) {
          if (selection[0] == variantValue1 && selection[1] == variantValue2) {
            variantID = variant.id;
            selectedVariant = variant;
          }
        } else {
          if (selection[0] == variantValue1) {
            variantID = variant.id;
            selectedVariant = variant;
          }
        }
      }

      activeVID = variantID;
      activeV = selectedVariant;

      if (isSubPage) {
        if (selectedVariant.available) {

          if ($('.step-sub').length > 0) {
            subscription = true;
            if (!formFinished) {
              collectSubscription(variantID, el, size, position, value);
            }
          } else {
            subscription = false;
            collectQty(variantID, false);
          }
        } else {
          $('.error-' + productID).removeClass('hide');
        }
      } else {

        if (selectedVariant.available) {
          addItemToCart(variantID, 1, subID, productID);
        } else {
          $('.error-' + productID).removeClass('hide');
        }
      }
    }
  }
}

function collectSubscription(variantID, el, size, position, value) {
  var subID;
  var frequency;
  var unitType;
  $('.step-sub').removeClass('hide');
  allSelected = true;

  $(document).on('click', '.subscription-btn', function (e) {
    $('.subscription-btn').removeClass('selected');
    subID = $(this).attr('data-id');
    frequency = $(this).attr('data-frequency');
    unitType = $(this).attr('data-unit-type');
    $(this).addClass('selected');
    collectQty(variantID, subID, frequency, unitType, el, size, position, value);
    subscriptionTxt = $(this).html();
  });

  if (isGift) {
    $('.subscription-btn').trigger('click');
  }
}

function collectQty(variantID, subID, frequency, unitType, el, size, position, value) {
  // var qty;
  $('.step-qty').removeClass('hide');
  if (isGift) {
    if (giftType == 'coffee') {
      $('.qty-tea-title').addClass('hide');
      $('.qty-coffee-title').removeClass('hide');
    } else {
      $('.qty-coffee-title').addClass('hide');
      $('.qty-tea-title').removeClass('hide');
    }
  }

  $(document).on('click', '.qty-selector', function (e) {
    $('.qty-selector').removeClass('selected');
    activeQty = $(this).attr('data-qty');
    $(this).addClass('selected');
    if (isGift) {
      if (formFinished) {
        parseVariants(el, false, subLength);
        letsReview(variantID, activeQty, subID, frequency, unitType, subLength);
      } else {
        collectSubTime(variantID, activeQty, subID, frequency, unitType, el, size, position, value);
      }
    } else {
      letsReview(variantID, activeQty, subID, frequency, unitType);
    }
  });
}

function collectSubTime(variantID, qty, subID, frequency, unitType, el, size, position, value) {
  $('.step-end').removeClass('hide');
  $(document).on('click', '.sub-length', function (e) {
    $('.sub-length').removeClass('selected');
    console.log('form', formFinished);
    subLength = $(this).attr('data-sub-length');

    parseVariants(lastEl, false, subLength);
    $(this).addClass('selected');

    letsReview(variantID, activeQty, subID, frequency, unitType, subLength);
  });
}

var v;
var q;
var s;
var price;
var f;
var u;
function letsReview(variantID, qty, subID, frequency, unitType, subLength) {
  var html = '';
  v = activeVID;
  q = activeQty;
  s = subID;
  f = frequency;
  u = unitType;
  formFinished = true;
  $('.lets_review').removeClass('hide');
  $('.button-container').removeClass('hide');

  if (isGift) {
    console.log(activeQty);
    if (activeQty == 2) {
      price = (0, _themeCurrency.formatMoney)(activeV.price * 2, theme.moneyFormat);
    } else {
      price = (0, _themeCurrency.formatMoney)(activeV.price, theme.moneyFormat);
    }
  } else {
    for (var i = 0; i < x.variants.length; i++) {
      if (x.variants[i].id == variantID) {

        if (activeQty == 2) {
          price = (0, _themeCurrency.formatMoney)(x.variants[i].price * 2, theme.moneyFormat);
        } else {
          price = (0, _themeCurrency.formatMoney)(x.variants[i].price, theme.moneyFormat);
        }
      }
    }
  }

  if (isGift) {
    if (giftType == 'coffee') {
      html += '<li class="qty-txt">COFFEE</li>';
    } else {
      html += '<li class="qty-txt">TEA</li>';
    }
  }

  selection.forEach(function (item, index) {
    if (item != 'Default Title') {
      html += '<li class="option-' + index + '">' + item + '</li>';
    }
  });
  if (subscriptionTxt != '') {
    html += '<li class="sub-txt">' + subscriptionTxt + '</li>';
  }

  if (isGift) {
    if (giftType == 'coffee') {
      html += '<li class="qty-txt">' + qty + ' BAGS</li>';
    } else {
      html += '<li class="qty-txt">' + qty + ' BOXES</li>';
    }

    html += '<li class="qty-txt">' + subLength + ' MONTHS</li>';
  } else {
    html += '<li class="qty-txt">' + qty + ' BAG</li>';
  }

  $('.add-sub-to-cart .price').html(' - ' + price);
  $('.lets_review--readout').html('<ul>' + html + '</ul>');
}

function reset() {

  selection = [];
  subID;
  subscription = false;

  $('.product_content--quick-add-btn').removeClass('selected');

  if (isSubPage) {
    $('.lets_review--readout').html('');
  }
}

$(document).on('click', '.add-sub-to-cart', function (e) {
  e.preventDefault();
  var productID = $(this).attr('data-product-id');
  addItemToCart(v, q, s, productID, f, u);
});

function addItemToCart(variant_id, qty, selling_plan, productID, frequency, unitType) {

  // return;


  if (subscription) {

    var data;
    variant_id = subscriptions.original_to_hidden_variant_map[variant_id];
    variant_id = variant_id.discount_variant_id;

    data = {
      "id": variant_id,
      "quantity": activeQty,
      "properties": {
        "shipping_interval_frequency": frequency,
        "shipping_interval_unit_type": unitType
      }
    };

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function success() {
        $('.success-' + productID).removeClass('hide');
        $('.button-container-' + productID).addClass('hide');

        $.get('/cart.js', '', function (data) {
          $('.cart-count').html(data.item_count);
          CartJS.getCart();
          showDropdown(productID);
          setTimeout(function () {
            $('.success-' + productID).addClass('hide');
            $('.variant-select-container-start-' + productID).removeClass('hide');
            $('.button-container-' + productID).removeClass('hide');

            // $('.variant-select-container').removeClass('hide');
          }, 3000);
        }, 'json');
      },
      error: function error(req, status, _error) {
        $('.error-' + productID).removeClass('hide');
        $('.button-container-' + productID).addClass('hide');
        setTimeout(function () {
          $('.error-' + productID).addClass('hide');
          $('.button-container-' + productID).removeClass('hide');
        }, 3000);
        // $('.variant-select-container').addClass('hide');
      }
    });
  } else {
    CartJS.addItem(activeVID, activeQty, {}, {
      success: function success(data, textStatus, jqXHR) {
        $('.success-' + productID).removeClass('hide');
        $('.button-container-' + productID).addClass('hide');

        $.get('/cart.js', '', function (data) {
          $('.cart-count').html(data.item_count);
          showDropdown(productID);
          setTimeout(function () {
            $('.success-' + productID).addClass('hide');
            $('.variant-select-container-start-' + productID).removeClass('hide');
            $('.button-container-' + productID).removeClass('hide');

            // $('.variant-select-container').removeClass('hide');
          }, 3000);
        }, 'json');
      },
      error: function error(req, status, _error2) {
        $('.error-' + productID).removeClass('hide');
        $('.button-container-' + productID).addClass('hide');
        setTimeout(function () {
          $('.error-' + productID).addClass('hide');
          $('.button-container-' + productID).removeClass('hide');
        }, 3000);
        // $('.variant-select-container').addClass('hide');

      }
    });
  }
}

function reload() {
  var container = document.getElementById("cart-drawer");
  var content = container.innerHTML;
  container.innerHTML = content;

  //this line is to watch the result in console , you can remove it later
}

function showDropdown(productID) {

  $("#cart-drawer").css('visibility', 'visible');
  $("#cart-drawer").animate({
    opacity: 1
  }, 200, function () {
    // Animation complete.
    setTimeout(function () {
      $("#cart-drawer").animate({
        opacity: 0
      }, 200, function () {
        // Animation complete.
        $("#cart-drawer").css('visibility', 'hidden');
      });
    }, 2000);
  });
}

// @end Quick ADD

$(document).on('click', '.slide_with_scroll--quick-add', function (e) {
  e.preventDefault();
  var variantID = $(this).attr('data-id');
  var productID = $(this).attr('data-product-id');
  var data = {
    "id": variantID,
    "quantity": 1
  };
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function success() {

      $.get('/cart.js', '', function (data) {
        $('.cart-count').html(data.item_count);
        CartJS.getCart();
        showDropdown(productID);
      }, 'json');
    },
    error: function error(req, status, _error3) {
      // alert(req.responseText);
    }
  });
});

$(document).on('click', '.update_subscription', function (e) {
  e.preventDefault();
  var selling_plan = $(this).attr('data-plan-id');
  var qty = $(this).attr('data-qty');
  var index = $(this).attr('data-index');
  var id = $(this).attr('data-variant-id');
  // return;


  var addToCartData = {
    updates: {}
  };

  addToCartData.updates[id] = 0;

  $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: addToCartData,
    dataType: 'json',
    success: function success(cart) {

      var data = {
        "id": id,
        "quantity": qty,
        "selling_plan": selling_plan
      };

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function success() {

          $.get('/cart.js', '', function (data) {
            location.reload();
          }, 'json');
        },
        error: function error(req, status, _error4) {
          // alert(req.responseText);
        }
      });
    }
  });
});